import { render } from "./EdicionModeloDhs.vue?vue&type=template&id=c4d90cd6&scoped=true"
import script from "./EdicionModeloDhs.vue?vue&type=script&lang=js"
export * from "./EdicionModeloDhs.vue?vue&type=script&lang=js"

import "./EdicionModeloDhs.vue?vue&type=style&index=0&id=c4d90cd6&scoped=true&lang=css"

import exportComponent from "/var/www/adm3.argusblack/adm3.argusblack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4d90cd6"]])

export default __exports__